<script setup lang="ts">
import ButtonGroupFilter from './ButtonGroupFilter.vue';

interface TimeFilterValue {
    departure?: string[];
    arrival?: string[];
}

interface IProps {
    origin?: string;
    destination?: string;
}
const { origin = '', destination = '' } = defineProps<IProps>();
const modelValue = defineModel<TimeFilterValue | null>({ default: null });
const clear = () => {
    modelValue.value = {};
};
const changeTime = (value: string[], index: number) => {
    if (index === 0) {
        modelValue.value = { ...modelValue.value, departure: [...value] };
    } else {
        modelValue.value = { ...modelValue.value, arrival: [...value] };
    }
};
defineExpose({ clear });
</script>

<template>
    <div class="time-filter">
        <div
            v-for="(title, key) in [
                `زمان حرکت از ${origin}`,
                `زمان رسیدن به ${destination}`,
            ]"
            :key
            class="filter-container"
        >
            <div class="title">
                {{ title }}
            </div>
            <ButtonGroupFilter
                column
                :model-value="
                    key === 0 ? modelValue?.departure : modelValue?.arrival
                "
                :items="[
                    {
                        title: '00:00 تا 08:00',
                        id: 'midnight',
                    },
                    {
                        title: '08:00 تا 18:00',
                        id: 'day',
                    },
                    {
                        title: '18:00 تا 00:00',
                        id: 'night',
                    },
                ]"
                @update:model-value="val => changeTime(val, key)"
            />
        </div>
    </div>
</template>

<style scoped lang="scss">
.time-filter {
    .filter-container {
        padding-bottom: 10px;
        .title {
            @include tg-m($w5, usePalette($p-cool-gray, $p-500));
            padding-bottom: 8px;
        }
    }
}
</style>
